export enum TaxonomyImportPageObjectModel {
  DropzoneInput = 'TaxonomyImport-DropzoneInput',
  UploadCancelButton = 'TaxonomyImport-UploadCancelButton',
  ConflictContinueButton = 'TaxonomyImport-ConflictContinueButton',
  ConflictBackButton = 'TaxonomyImport-ConflictBackButton',
  ConflictKeepCheckbox = 'TaxonomyImport-ConflictKeepCheckbox',
  PreviewImportButton = 'TaxonomyImport-PreviewImportButton',
  PreviewBackButton = 'TaxonomyImport-PreviewBackButton',
  ResultCloseButton = 'TaxonomyImport-ResultCloseButton',
  ResultMessage = 'TaxonomyImport-ResultMessage',
  DialogTitle = 'TaxonomyImport-DialogTitle',
  ConflictAdditions = 'TaxonomyImport-ConflictAdditions',
  ConflictRemovals = 'TaxonomyImport-ConflictRemovals',
  ConflictMoves = 'TaxonomyImport-ConflictMoves',
  ConflictUnchanged = 'TaxonomyImport-ConflictUnchanged',
  ConflictLabeled = 'TaxonomyImport-ConflictLabeled',
}
